export const enum PageId {
  ANALYZING = 'analyzing',
  START = 'start',
  QUESTION_1 = 'question_1',
  QUESTION_2 = 'question_2',
  QUESTION_3 = 'question_3',
  QUESTION_4 = 'question_4',
  SPEED_FEEDBACK = 'speed_feedback',
  QUESTION_5 = 'question_5',
  QUESTION_6 = 'question_6',
  QUESTION_7 = 'question_7',
  QUESTION_8 = 'question_8',
  QUESTION_9 = 'question_9',
  QUESTION_10 = 'question_10',
  QUESTION_11 = 'question_11',
  QUESTION_12 = 'question_12',
  SMARTNESS_FEEDBACK = 'smartness_feedback',
  QUESTION_13 = 'question_13',
  QUESTION_14 = 'question_14',
  QUESTION_15 = 'question_15',
  QUESTION_16 = 'question_16',
  QUESTION_17 = 'question_17',
  QUESTION_18 = 'question_18',
  QUESTION_19 = 'question_19',
  QUESTION_20 = 'question_20',
  LOGICAL_SKILLS_FEEDBACK = 'logical_skills_feedback',
  QUESTION_21 = 'question_21',
  QUESTION_22 = 'question_22',
  QUESTION_23 = 'question_23',
  QUESTION_24 = 'question_24',
  QUESTION_25 = 'question_25',
  AGE_QUESTION = 'age_question',
  EDUCATION_QUESTION = 'education_question',
  DISCOVER_FEEDBACKS = 'discover_feedbacks',
  PREPARE_FLOW = 'prepare_flow',
  EMAIL = 'email',
  OFFER = 'offer',
  PAYMENT = 'payment',
  REGISTRATION = 'registration',
  NAME_ENTRY = 'name_entry',
  CERTIFICATE = 'certificate',
  REPORT = 'report',

  // intl_1t cohort
  START_INTL_1T = 'start_intl_1t',
  QUESTION_1_INTL_1T = 'question_1_intl_1t',
  QUESTION_2_INTL_1T = 'question_2_intl_1t',
  QUESTION_3_INTL_1T = 'question_3_intl_1t',
  QUESTION_4_INTL_1T = 'question_4_intl_1t',
  SPEED_FEEDBACK_INTL_1T = 'speed_feedback_intl_1t',
  QUESTION_5_INTL_1T = 'question_5_intl_1t',
  QUESTION_6_INTL_1T = 'question_6_intl_1t',
  QUESTION_7_INTL_1T = 'question_7_intl_1t',
  QUESTION_8_INTL_1T = 'question_8_intl_1t',
  QUESTION_9_INTL_1T = 'question_9_intl_1t',
  QUESTION_10_INTL_1T = 'question_10_intl_1t',
  QUESTION_11_INTL_1T = 'question_11_intl_1t',
  QUESTION_12_INTL_1T = 'question_12_intl_1t',
  SMARTNESS_FEEDBACK_INTL_1T = 'smartness_feedback_intl_1t',
  QUESTION_13_INTL_1T = 'question_13_intl_1t',
  QUESTION_14_INTL_1T = 'question_14_intl_1t',
  QUESTION_15_INTL_1T = 'question_15_intl_1t',
  QUESTION_16_INTL_1T = 'question_16_intl_1t',
  QUESTION_17_INTL_1T = 'question_17_intl_1t',
  QUESTION_18_INTL_1T = 'question_18_intl_1t',
  QUESTION_19_INTL_1T = 'question_19_intl_1t',
  QUESTION_20_INTL_1T = 'question_20_intl_1t',
  LOGICAL_SKILLS_FEEDBACK_INTL_1T = 'logical_skills_feedback_intl_1t',
  QUESTION_21_INTL_1T = 'question_21_intl_1t',
  QUESTION_22_INTL_1T = 'question_22_intl_1t',
  QUESTION_23_INTL_1T = 'question_23_intl_1t',
  QUESTION_24_INTL_1T = 'question_24_intl_1t',
  QUESTION_25_INTL_1T = 'question_25_intl_1t',
  AGE_QUESTION_INTL_1T = 'age_question_intl_1t',
  EDUCATION_QUESTION_INTL_1T = 'education_question_intl_1t',
  DISCOVER_FEEDBACKS_INTL_1T = 'discover_feedbacks_intl_1t',
  PREPARE_FLOW_INTL_1T = 'prepare_flow_intl_1t',
  EMAIL_INTL_1T = 'email_intl_1t',
  OFFER_INTL_1T = 'offer_intl_1t',
  PAYMENT_INTL_1T = 'payment_intl_1t',
  REGISTRATION_INTL_1T = 'registration_intl_1t',
  NAME_ENTRY_INTL_1T = 'name_entry_intl_1t',
  CERTIFICATE_INTL_1T = 'certificate_intl_1t',
  REPORT_INTL_1T = 'report_intl_1t',

  // intl_2 cohort
  ANALYZING_INTL_2 = 'analyzing_intl_2',
  START_INTL_2 = 'start_intl_2',
  QUESTION_1_INTL_2 = 'question_1_intl_2',
  QUESTION_2_INTL_2 = 'question_2_intl_2',
  QUESTION_3_INTL_2 = 'question_3_intl_2',
  QUESTION_4_INTL_2 = 'question_4_intl_2',
  SPEED_FEEDBACK_INTL_2 = 'speed_feedback_intl_2',
  QUESTION_5_INTL_2 = 'question_5_intl_2',
  QUESTION_6_INTL_2 = 'question_6_intl_2',
  QUESTION_7_INTL_2 = 'question_7_intl_2',
  QUESTION_8_INTL_2 = 'question_8_intl_2',
  QUESTION_9_INTL_2 = 'question_9_intl_2',
  QUESTION_10_INTL_2 = 'question_10_intl_2',
  QUESTION_11_INTL_2 = 'question_11_intl_2',
  QUESTION_12_INTL_2 = 'question_12_intl_2',
  SMARTNESS_FEEDBACK_INTL_2 = 'smartness_feedback_intl_2',
  QUESTION_13_INTL_2 = 'question_13_intl_2',
  QUESTION_14_INTL_2 = 'question_14_intl_2',
  QUESTION_15_INTL_2 = 'question_15_intl_2',
  QUESTION_16_INTL_2 = 'question_16_intl_2',
  QUESTION_17_INTL_2 = 'question_17_intl_2',
  QUESTION_18_INTL_2 = 'question_18_intl_2',
  QUESTION_19_INTL_2 = 'question_19_intl_2',
  QUESTION_20_INTL_2 = 'question_20_intl_2',
  LOGICAL_SKILLS_FEEDBACK_INTL_2 = 'logical_skills_feedback_intl_2',
  QUESTION_21_INTL_2 = 'question_21_intl_2',
  QUESTION_22_INTL_2 = 'question_22_intl_2',
  QUESTION_23_INTL_2 = 'question_23_intl_2',
  QUESTION_24_INTL_2 = 'question_24_intl_2',
  QUESTION_25_INTL_2 = 'question_25_intl_2',
  AGE_QUESTION_INTL_2 = 'age_question_intl_2',
  EDUCATION_QUESTION_INTL_2 = 'education_question_intl_2',
  DISCOVER_FEEDBACKS_INTL_2 = 'discover_feedbacks_intl_2',
  PREPARE_FLOW_INTL_2 = 'prepare_flow_intl_2',
  EMAIL_INTL_2 = 'email_intl_2',
  EMAIL_CONSENT_INTL_2 = 'email_consent_intl_2',
  OFFER_INTL_2 = 'offer_intl_2',
  SPECIAL_DISCOUNT_INTL_2 = 'special_discount_intl_2',
  CANCEL_OFFER_INTL_2 = 'cancel_offer_intl_2',
  PAYMENT_INTL_2 = 'payment_intl_2',
  CHECKOUT_INTL_2 = 'checkout_intl_2',
  UPSELL_INTL_2 = 'upsell_intl_2',
  REGISTRATION_INTL_2 = 'registration_intl_2',
  NAME_ENTRY_INTL_2 = 'name_entry_intl_2',
  CERTIFICATE_INTL_2 = 'certificate_intl_2',
  REPORT_INTL_2 = 'report_intl_2',

  // intl_2lw cohort
  ANALYZING_INTL_2LW = 'analyzing_intl_2lw',
  INTRO_CERTIFICATE_INTL_2LW = 'intro_certificate_intl_2lw',
  START_INTL_2LW = 'start_intl_2lw',
  QUESTION_1_INTL_2LW = 'question_1_intl_2lw',
  QUESTION_2_INTL_2LW = 'question_2_intl_2lw',
  QUESTION_3_INTL_2LW = 'question_3_intl_2lw',
  QUESTION_4_INTL_2LW = 'question_4_intl_2lw',
  SPEED_FEEDBACK_INTL_2LW = 'speed_feedback_intl_2lw',
  QUESTION_5_INTL_2LW = 'question_5_intl_2lw',
  QUESTION_6_INTL_2LW = 'question_6_intl_2lw',
  QUESTION_7_INTL_2LW = 'question_7_intl_2lw',
  QUESTION_8_INTL_2LW = 'question_8_intl_2lw',
  QUESTION_9_INTL_2LW = 'question_9_intl_2lw',
  QUESTION_10_INTL_2LW = 'question_10_intl_2lw',
  QUESTION_11_INTL_2LW = 'question_11_intl_2lw',
  QUESTION_12_INTL_2LW = 'question_12_intl_2lw',
  SMARTNESS_FEEDBACK_INTL_2LW = 'smartness_feedback_intl_2lw',
  QUESTION_13_INTL_2LW = 'question_13_intl_2lw',
  QUESTION_14_INTL_2LW = 'question_14_intl_2lw',
  QUESTION_15_INTL_2LW = 'question_15_intl_2lw',
  QUESTION_16_INTL_2LW = 'question_16_intl_2lw',
  QUESTION_17_INTL_2LW = 'question_17_intl_2lw',
  QUESTION_18_INTL_2LW = 'question_18_intl_2lw',
  QUESTION_19_INTL_2LW = 'question_19_intl_2lw',
  QUESTION_20_INTL_2LW = 'question_20_intl_2lw',
  LOGICAL_SKILLS_FEEDBACK_INTL_2LW = 'logical_skills_feedback_intl_2lw',
  QUESTION_21_INTL_2LW = 'question_21_intl_2lw',
  QUESTION_22_INTL_2LW = 'question_22_intl_2lw',
  QUESTION_23_INTL_2LW = 'question_23_intl_2lw',
  QUESTION_24_INTL_2LW = 'question_24_intl_2lw',
  QUESTION_25_INTL_2LW = 'question_25_intl_2lw',
  AGE_QUESTION_INTL_2LW = 'age_question_intl_2lw',
  EDUCATION_QUESTION_INTL_2LW = 'education_question_intl_2lw',
  DISCOVER_FEEDBACKS_INTL_2LW = 'discover_feedbacks_intl_2lw',
  PREPARE_FLOW_INTL_2LW = 'prepare_flow_intl_2lw',
  EMAIL_INTL_2LW = 'email_intl_2lw',
  EMAIL_CONSENT_INTL_2LW = 'email_consent_intl_2lw',
  OFFER_INTL_2LW = 'offer_intl_2lw',
  SPECIAL_DISCOUNT_INTL_2LW = 'special_discount_intl_2lw',
  CANCEL_OFFER_INTL_2LW = 'cancel_offer_intl_2lw',
  PAYMENT_INTL_2LW = 'payment_intl_2lw',
  CHECKOUT_INTL_2LW = 'checkout_intl_2lw',
  UPSELL_INTL_2LW = 'upsell_intl_2lw',
  REGISTRATION_INTL_2LW = 'registration_intl_2lw',
  NAME_ENTRY_INTL_2LW = 'name_entry_intl_2lw',
  CERTIFICATE_INTL_2LW = 'certificate_intl_2lw',
  LEARNWORLDS_REDIRECT_INTL_2LW = 'learnworlds_redirect_intl_2lw',
  REPORT_INTL_2LW = 'report_intl_2lw',
  OFFER_INTL_D60 = 'offer_intl_d60',
  PAYMENT_INTL_D60 = 'payment_intl_d60',
  CHECKOUT_INTL_D60 = 'checkout_intl_d60',
  UPSELL_INTL_D60 = 'upsell_intl_d60',
  REGISTRATION_INTL_D60 = 'registration_intl_d60',
  NAME_ENTRY_INTL_D60 = 'name_entry_intl_d60',
  CERTIFICATE_INTL_D60 = 'certificate_intl_d60',
  LEARNWORLDS_REDIRECT_INTL_D60 = 'learnworlds_redirect_intl_d60',
  REPORT_INTL_D60 = 'report_intl_d60',
  OFFER_INTL_D70 = 'offer_intl_d70',
  PAYMENT_INTL_D70 = 'payment_intl_d70',
  CHECKOUT_INTL_D70 = 'checkout_intl_d70',
  UPSELL_INTL_D70 = 'upsell_intl_d70',
  REGISTRATION_INTL_D70 = 'registration_intl_d70',
  NAME_ENTRY_INTL_D70 = 'name_entry_intl_d70',
  CERTIFICATE_INTL_D70 = 'certificate_intl_d70',
  LEARNWORLDS_REDIRECT_INTL_D70 = 'learnworlds_redirect_intl_d70',
  REPORT_INTL_D70 = 'report_intl_d70',

  // intl_hlwn70 cohort
  OFFER_INTL_HLWN70 = 'offer_intl_hlwn70',
  SPECIAL_DISCOUNT_INTL_HLWN70 = 'special_discount_intl_hlwn70',
  CANCEL_OFFER_INTL_HLWN70 = 'cancel_offer_intl_hlwn70',
  PAYMENT_INTL_HLWN70 = 'payment_intl_hlwn70',
  CHECKOUT_INTL_HLWN70 = 'checkout_intl_hlwn70',
  UPSELL_INTL_HLWN70 = 'upsell_intl_hlwn70',
  REGISTRATION_INTL_HLWN70 = 'registration_intl_hlwn70',
  NAME_ENTRY_INTL_HLWN70 = 'name_entry_intl_hlwn70',
  CERTIFICATE_INTL_HLWN70 = 'certificate_intl_hlwn70',
  LEARNWORLDS_REDIRECT_INTL_HLWN70 = 'learnworlds_redirect_intl_hlwn70',
  REPORT_INTL_HLWN70 = 'report_intl_hlwn70',

  // intl_3 cohort
  ANALYZING_INTL_3 = 'analyzing_intl_3',
  START_INTL_3 = 'start_intl_3',
  PUZZLES_ENJOYMENT_INTL_3 = 'puzzles_enjoyment_intl_3',
  APPLY_KNOWLEDGE_REAL_LIFE_INTL_3 = 'apply_knowledge_real_life_intl_3',
  NOTICE_PATTERNS_INTL_3 = 'notice_patterns_intl_3',
  STAY_CURIOUS_INTL_3 = 'stay_curious_intl_3',
  LONG_FOCUS_INTL_3 = 'long_focus_intl_3',
  PERSONALIZE_TEST_FEEDBACK_INTL_3 = 'personalize_test_feedback_intl_3',
  QUESTION_1_INTL_3 = 'question_1_intl_3',
  QUESTION_2_INTL_3 = 'question_2_intl_3',
  QUESTION_3_INTL_3 = 'question_3_intl_3',
  QUESTION_4_INTL_3 = 'question_4_intl_3',
  SPEED_FEEDBACK_INTL_3 = 'speed_feedback_intl_3',
  QUESTION_5_INTL_3 = 'question_5_intl_3',
  QUESTION_6_INTL_3 = 'question_6_intl_3',
  QUESTION_7_INTL_3 = 'question_7_intl_3',
  QUESTION_8_INTL_3 = 'question_8_intl_3',
  QUESTION_9_INTL_3 = 'question_9_intl_3',
  QUESTION_10_INTL_3 = 'question_10_intl_3',
  QUESTION_11_INTL_3 = 'question_11_intl_3',
  QUESTION_12_INTL_3 = 'question_12_intl_3',
  SMARTNESS_FEEDBACK_INTL_3 = 'smartness_feedback_intl_3',
  QUESTION_13_INTL_3 = 'question_13_intl_3',
  QUESTION_14_INTL_3 = 'question_14_intl_3',
  QUESTION_15_INTL_3 = 'question_15_intl_3',
  QUESTION_16_INTL_3 = 'question_16_intl_3',
  QUESTION_17_INTL_3 = 'question_17_intl_3',
  QUESTION_18_INTL_3 = 'question_18_intl_3',
  QUESTION_19_INTL_3 = 'question_19_intl_3',
  QUESTION_20_INTL_3 = 'question_20_intl_3',
  LOGICAL_SKILLS_FEEDBACK_INTL_3 = 'logical_skills_feedback_intl_3',
  QUESTION_21_INTL_3 = 'question_21_intl_3',
  QUESTION_22_INTL_3 = 'question_22_intl_3',
  QUESTION_23_INTL_3 = 'question_23_intl_3',
  QUESTION_24_INTL_3 = 'question_24_intl_3',
  QUESTION_25_INTL_3 = 'question_25_intl_3',
  AGE_QUESTION_INTL_3 = 'age_question_intl_3',
  EDUCATION_QUESTION_INTL_3 = 'education_question_intl_3',
  DISCOVER_FEEDBACKS_INTL_3 = 'discover_feedbacks_intl_3',
  PREPARE_FLOW_INTL_3 = 'prepare_flow_intl_3',
  EMAIL_INTL_3 = 'email_intl_3',
  OFFER_INTL_3 = 'offer_intl_3',
  SPECIAL_DISCOUNT_INTL_3 = 'special_discount_intl_3',
  CANCEL_OFFER_INTL_3 = 'cancel_offer_intl_3',
  PAYMENT_INTL_3 = 'payment_intl_3',
  REGISTRATION_INTL_3 = 'registration_intl_3',
  NAME_ENTRY_INTL_3 = 'name_entry_intl_3',
  CERTIFICATE_INTL_3 = 'certificate_intl_3',
  REPORT_INTL_3 = 'report_intl_3',

  // intl_mw cohort
  ANALYZING_INTL_MW = 'analyzing_intl_mw',
  START_INTL_MW = 'start_intl_mw',
  LIVING_UP_POTENTIAL_INTL_MW = 'living_up_potential_intl_mw',
  STRUGGLE_MOST_INTL_MW = 'struggle_most_intl_mw',
  STUCK_AREAS_INTL_MW = 'stuck_areas_intl_mw',
  REASON_TO_START_INTL_MW = 'reason_to_start_intl_mw',
  GOOD_COMPANY_INTL_MW = 'good_company_intl_mw',
  LITTLE_INTEREST_INTL_MW = 'little_interest_intl_mw',
  EMOTION_SHIFTS_INTL_MW = 'emotion_shifts_intl_mw',
  CALM_DOWN_INTL_MW = 'calm_down_intl_mw',
  RECHARGING_INTL_MW = 'recharging_intl_mw',
  ACCEPT_COMPLIMENTS_INTL_MW = 'accept_compliments_intl_mw',
  PRIORITIZE_OTHERS_INTL_MW = 'prioritize_others_intl_mw',
  LEAN_ON_SOMEONE_INTL_MW = 'lean_on_someone_intl_mw',
  UNDERSTOOD_BY_OTHERS_INTL_MW = 'understood_by_others_intl_mw',
  WE_FEEL_YOU_INTL_MW = 'we_feel_you_intl_mw',
  OVERTHINKING_DECISIONS_INTL_MW = 'overthinking_decisions_intl_mw',
  AUTOPILOT_INTL_MW = 'autopilot_intl_mw',
  UNABLE_TO_START_INTL_MW = 'unable_to_start_intl_mw',
  DISTRACTIONS_INTL_MW = 'distractions_intl_mw',
  MEANING_TO_DO_INTL_MW = 'meaning_to_do_intl_mw',
  OTHER_SIDE_INTL_MW = 'other_side_intl_mw',
  GENUINE_STRENGTHS_INTL_MW = 'genuine_strengths_intl_mw',
  TIME_INVESTMENT_INTL_MW = 'time_investment_intl_mw',
  HEAR_ABOUT_US_INTL_MW = 'hear_about_us_intl_mw',
  PREPARE_FLOW_INTL_MW = 'prepare_flow_intl_mw',
  PATTERNS_IMPACT_INTL_MW = 'patterns_impact_intl_mw',
  EMAIL_INTL_MW = 'email_intl_mw',
  OFFER_INTL_MW = 'offer_intl_mw',
  SPECIAL_DISCOUNT_INTL_MW = 'special_discount_intl_mw',
  CANCEL_OFFER_INTL_MW = 'cancel_offer_intl_mw',
  PAYMENT_INTL_MW = 'payment_intl_mw',
  REGISTRATION_INTL_MW = 'registration_intl_mw',
  NAME_ENTRY_INTL_MW = 'name_entry_intl_mw',
  REPORT_INTL_MW = 'report_intl_mw',
}
